import { api } from 'api'
import { AxiosResponse } from 'axios'
import { path } from 'ramda'
import { Assignment } from 'typings/common_defs'

type GetAssignmentDetailRequest = {
  assignmentId?: number
}

type GetAssignmentDetailResponse = Assignment

type GetAssignmentDetailResponseDTO = {
  data: {
    company: {
      assignment: Assignment
    }
  }
}

export const getAssignmentDetail = async ({
  assignmentId,
}: GetAssignmentDetailRequest): Promise<GetAssignmentDetailResponse> => {
  const data = await api.post<
    GetAssignmentDetailResponseDTO,
    AxiosResponse<GetAssignmentDetailResponseDTO>
  >('/company/graphql_dispatch/assignment_detail_b60f4459', { assignmentId })

  return path(['data', 'data', 'company', 'assignment'], data)
}
